@if (isActive()) {
  <section class="user-admin">
    <div class="user-admin__header">
      <div>
        <h2 class="user-admin__title">
          {{ mode() === 'tenant-provisioning' ? 'Klienci i tenanty' : 'Użytkownicy' }}
        </h2>
        <p class="user-admin__meta">
          {{
            mode() === 'tenant-provisioning'
              ? 'Tworzenie nowego klienta z administratorem biznesowym.'
              : 'Przeglądaj i zarządzaj użytkownikami bieżącego tenanta.'
          }}
        </p>
      </div>

      @if (mode() === 'tenant-users' && !isCreating() && !userPendingEdit()) {
        <div class="app-view-toggle" role="tablist" aria-label="Tryb wyświetlania użytkowników">
          <button
            class="app-view-toggle__button"
            type="button"
            [class.app-view-toggle__button--active]="viewMode() === 'list'"
            [attr.aria-pressed]="viewMode() === 'list'"
            aria-label="Widok listy"
            title="Widok listy"
            (click)="setViewMode('list')"
          >
            <span class="fa-solid fa-table-list" aria-hidden="true"></span>
          </button>
          <button
            class="app-view-toggle__button"
            type="button"
            [class.app-view-toggle__button--active]="viewMode() === 'tiles'"
            [attr.aria-pressed]="viewMode() === 'tiles'"
            aria-label="Widok kart"
            title="Widok kart"
            (click)="setViewMode('tiles')"
          >
            <span class="fa-solid fa-table-cells-large" aria-hidden="true"></span>
          </button>
        </div>
      }
    </div>

    @if (error(); as errorText) {
      <div class="form-message"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ errorText }}</div>
    }

    @if (message(); as messageText) {
      <div class="user-admin__success"><span class="app-message__icon app-message__icon--success fa-solid fa-circle-check" aria-hidden="true"></span> {{ messageText }}</div>
    }

    @if (mode() === 'tenant-provisioning') {
      <form
        class="app-panel user-admin__form"
        [formGroup]="provisioningForm"
        (ngSubmit)="submitProvisioning()"
      >
        <div class="app-panel__header">
          <h3 class="app-panel__title">Nowy klient</h3>
          <p class="app-panel__meta">
            Superadmin zakłada tenanta i pierwszego administratora klienta.
          </p>
        </div>

        <div class="user-admin__grid">
          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('tenant_name')">
            <span class="app-field__label">Nazwa klienta</span>
            <input type="text" formControlName="tenant_name" autocomplete="organization" [attr.aria-invalid]="isProvisioningFieldInvalid('tenant_name')" />
            @if (provisioningFieldError('tenant_name'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>

          <label class="app-field app-field--select" [class.app-field--invalid]="isProvisioningFieldInvalid('service')">
            <span class="app-field__label">Serwis</span>
            <select formControlName="service" [attr.aria-invalid]="isProvisioningFieldInvalid('service')">
              <option value="BHP">BHP</option>
            </select>
            @if (provisioningFieldError('service'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>

          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('tenant_schema')">
            <span class="app-field__label">Schema</span>
            <input type="text" formControlName="tenant_schema" autocomplete="off" placeholder="np. testowy_klient" [attr.aria-invalid]="isProvisioningFieldInvalid('tenant_schema')" />
            @if (provisioningFieldError('tenant_schema'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>

          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('user_limit')">
            <span class="app-field__label">Limit użytkowników</span>
            <input type="number" min="1" formControlName="user_limit" [attr.aria-invalid]="isProvisioningFieldInvalid('user_limit')" />
            @if (provisioningFieldError('user_limit'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>
        </div>

        <div class="user-admin__grid">
          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('admin_email')">
            <span class="app-field__label">Email admina</span>
            <input type="email" formControlName="admin_email" autocomplete="email" placeholder="np. admin@firma.pl" [attr.aria-invalid]="isProvisioningFieldInvalid('admin_email')" />
            @if (provisioningFieldError('admin_email'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>

          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('admin_password')">
            <span class="app-field__label">Hasło startowe</span>
            <input type="password" formControlName="admin_password" autocomplete="new-password" [attr.aria-invalid]="isProvisioningFieldInvalid('admin_password')" />
            @if (provisioningFieldError('admin_password'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>
        </div>

        <div class="user-admin__grid">
          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('admin_first_name')">
            <span class="app-field__label">Imię admina</span>
            <input type="text" formControlName="admin_first_name" autocomplete="given-name" [attr.aria-invalid]="isProvisioningFieldInvalid('admin_first_name')" />
            @if (provisioningFieldError('admin_first_name'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>

          <label class="app-field" [class.app-field--invalid]="isProvisioningFieldInvalid('admin_last_name')">
            <span class="app-field__label">Nazwisko admina</span>
            <input type="text" formControlName="admin_last_name" autocomplete="family-name" [attr.aria-invalid]="isProvisioningFieldInvalid('admin_last_name')" />
            @if (provisioningFieldError('admin_last_name'); as fieldError) {
              <span class="user-admin__field-error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ fieldError }}</span>
            }
          </label>
        </div>

        <div class="app-panel__actions">
          <button
            class="primary-button primary-button--compact"
            type="submit"
            [disabled]="isSaving()"
          >
            <span class="fa-solid fa-building-user" aria-hidden="true"></span>
            {{ isSaving() ? 'Tworzenie...' : 'Utwórz klienta' }}
          </button>
        </div>
      </form>

      @if (tenantPendingEdit(); as tenant) {
        <form
          class="app-panel user-admin__form"
          [formGroup]="tenantEditForm"
          (ngSubmit)="submitTenantEdit()"
        >
          <div class="app-panel__header">
            <h3 class="app-panel__title">Edycja klienta</h3>
            <p class="app-panel__meta">
              {{ tenant.schema }} · Użytkownicy: {{ editedTenantUsers().length }} /
              {{ tenant.user_limit ?? 'bez limitu' }}
            </p>
          </div>

          <div class="user-admin__grid user-admin__grid--compact">
            <label class="app-field">
              <span class="app-field__label">Nazwa klienta</span>
              <input type="text" formControlName="name" autocomplete="organization" />
            </label>

            <label class="app-field">
              <span class="app-field__label">Limit użytkowników</span>
              <input type="number" min="1" formControlName="user_limit" />
            </label>

            <label class="app-switch user-admin__switch">
              <input type="checkbox" formControlName="is_active" />
              <span class="app-switch__indicator" aria-hidden="true"></span>
              Tenant aktywny
            </label>
          </div>

          <div class="app-panel__actions">
            <button
              class="secondary-button secondary-button--compact"
              type="button"
              [disabled]="isSaving()"
              (click)="cancelTenantEdit()"
            >
              Anuluj
            </button>
            <button
              class="primary-button primary-button--compact"
              type="submit"
              [disabled]="isSaving()"
            >
              <span class="fa-solid fa-floppy-disk" aria-hidden="true"></span>
              {{ isSaving() ? 'Zapisywanie...' : 'Zapisz klienta' }}
            </button>
          </div>
        </form>

        <form
          class="app-panel user-admin__form"
          [formGroup]="businessAdminReplacementForm"
          (ngSubmit)="replaceBusinessAdmin()"
        >
          <div class="app-panel__header">
            <h3 class="app-panel__title">Zmiana administratora biznesowego</h3>
            <p class="app-panel__meta">
              Nowy administrator przejmie wszystkie audyty klienta. Dotychczasowi administratorzy
              zostaną dezaktywowani po poprawnym przepisaniu audytów.
            </p>
          </div>

          <div class="user-admin__grid">
            <label class="app-field app-field--select">
              <span class="app-field__label">Administrator zastępowany</span>
              <select formControlName="previous_admin_user_code">
                @for (admin of editedTenantActiveBusinessAdmins(); track admin.user_code) {
                  <option [value]="admin.user_code">
                    {{ admin.first_name }} {{ admin.last_name }} · {{ admin.email }}
                  </option>
                }
              </select>
            </label>

            <label class="app-field">
              <span class="app-field__label">Email nowego administratora</span>
              <input type="email" formControlName="email" autocomplete="email" />
            </label>
          </div>

          <div class="user-admin__grid">
            <label class="app-field">
              <span class="app-field__label">Imię</span>
              <input type="text" formControlName="first_name" autocomplete="given-name" />
            </label>
            <label class="app-field">
              <span class="app-field__label">Nazwisko</span>
              <input type="text" formControlName="last_name" autocomplete="family-name" />
            </label>
          </div>

          <div class="user-admin__grid user-admin__grid--compact">
            <label class="app-field">
              <span class="app-field__label">Hasło startowe</span>
              <input type="password" formControlName="password" autocomplete="new-password" />
              @if (businessAdminReplacementForm.controls.password.dirty && businessAdminReplacementForm.controls.password.hasError('strongPassword')) {
                <span class="user-admin__field-error">
                  Hasło musi mieć co najmniej 7 znaków i zawierać małą literę, dużą literę, cyfrę oraz znak specjalny.
                </span>
              }
            </label>
            <label class="app-switch user-admin__switch">
              <input type="checkbox" formControlName="must_change_password" />
              <span class="app-switch__indicator" aria-hidden="true"></span>
              Zmiana hasła po pierwszym logowaniu
            </label>
          </div>

          <label class="app-switch">
            <input type="checkbox" formControlName="confirm" />
            <span class="app-switch__indicator" aria-hidden="true"></span>
            Potwierdzam dezaktywację dotychczasowych administratorów i przepisanie wszystkich audytów.
          </label>

          <div class="app-panel__actions">
            <button
              class="primary-button primary-button--compact"
              type="submit"
              [disabled]="isSaving() || businessAdminReplacementForm.invalid || !editedTenantActiveBusinessAdmins().length"
            >
              <span class="fa-solid fa-user-shield" aria-hidden="true"></span>
              {{ isSaving() ? 'Zmienianie administratora...' : 'Zmień administratora' }}
            </button>
          </div>
        </form>

        <form
          class="app-panel user-admin__form"
          [formGroup]="tenantUserForm"
          (ngSubmit)="submitTenantUser()"
        >
          <div class="app-panel__header">
            <h3 class="app-panel__title">Użytkownicy klienta</h3>
            <p class="app-panel__meta">
              {{
                editedTenantUserLimitReached()
                  ? 'Limit użytkowników został osiągnięty.'
                  : 'Dodaj użytkownika do wybranego tenanta.'
              }}
            </p>
          </div>

          <div class="user-admin__grid">
            <label class="app-field">
              <span class="app-field__label">Email</span>
              <input
                type="email"
                formControlName="email"
                autocomplete="email"
                [disabled]="editedTenantUserLimitReached()"
              />
            </label>

            <label class="app-field">
              <span class="app-field__label">Hasło startowe</span>
              <input
                type="password"
                formControlName="password"
                autocomplete="new-password"
                [disabled]="editedTenantUserLimitReached()"
              />
            </label>
          </div>

          <div class="user-admin__grid">
            <label class="app-field">
              <span class="app-field__label">Imię</span>
              <input
                type="text"
                formControlName="first_name"
                autocomplete="given-name"
                [disabled]="editedTenantUserLimitReached()"
              />
            </label>

            <label class="app-field">
              <span class="app-field__label">Nazwisko</span>
              <input
                type="text"
                formControlName="last_name"
                autocomplete="family-name"
                [disabled]="editedTenantUserLimitReached()"
              />
            </label>
          </div>

          <div class="user-admin__grid user-admin__grid--compact">
            <label class="app-field app-field--select">
              <span class="app-field__label">Rola</span>
              <select formControlName="role" [disabled]="editedTenantUserLimitReached()">
                <option value="MANAGER">Menedżer</option>
                <option value="AUDITOR">Audytor</option>
              </select>
            </label>

            <label class="app-switch user-admin__switch">
              <input
                type="checkbox"
                formControlName="is_active"
                [disabled]="editedTenantUserLimitReached()"
              />
              <span class="app-switch__indicator" aria-hidden="true"></span>
              Aktywny
            </label>
          </div>

          <div class="app-panel__actions">
            <button
              class="primary-button primary-button--compact"
              type="submit"
              [disabled]="isSaving() || editedTenantUserLimitReached()"
            >
              <span class="fa-solid fa-user-plus" aria-hidden="true"></span>
              {{ isSaving() ? 'Tworzenie...' : 'Dodaj użytkownika klienta' }}
            </button>
          </div>

          @if (!editedTenantUsers().length) {
            <div class="app-empty-state"><span class="app-message__icon app-message__icon--info fa-solid fa-circle-info" aria-hidden="true"></span> Brak użytkowników w tym tenancie.</div>
          } @else {
            <div class="app-data-table-shell">
              <table class="app-data-table">
                <thead>
                  <tr class="app-data-table__header-row">
                    <th>Email (login)</th>
                    <th>Imię i nazwisko</th>
                    <th>Rola</th>
                    <th>Status</th>
                    <th class="user-admin__actions-header">Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  @for (user of editedTenantUsers(); track user.user_code) {
                    <tr>
                      <td>{{ user.email }}</td>
                      <td>{{ user.first_name }} {{ user.last_name }}</td>
                      <td>{{ user.role }}</td>
                      <td>
                        <span
                          class="app-status-chip"
                          [class.app-status-chip--active]="user.is_active"
                          [class.app-status-chip--archived]="!user.is_active"
                        >
                          {{ user.is_active ? 'Aktywny' : 'Nieaktywny' }}
                        </span>
                      </td>
                      <td class="user-admin__actions-cell">
                        @if (canManageUser(user)) {
                          <div class="app-row-actions">
                            <button
                              class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                              type="button"
                              title="Edytuj użytkownika"
                              aria-label="Edytuj użytkownika"
                              [disabled]="isSaving() || userStatusPendingCode() === user.user_code"
                              (click)="editUser(user)"
                            >
                              <span class="fa-solid fa-pen-to-square" aria-hidden="true"></span>
                            </button>
                            @if (user.is_active) {
                              <button
                                class="primary-button primary-button--compact app-row-action-button"
                                type="button"
                                title="Dezaktywuj użytkownika"
                                aria-label="Dezaktywuj użytkownika"
                                [disabled]="
                                  isSaving() || userStatusPendingCode() === user.user_code
                                "
                                (click)="toggleUserActive(user)"
                              >
                                <span class="fa-solid fa-user-slash" aria-hidden="true"></span>
                              </button>
                            } @else {
                              <button
                                class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                                type="button"
                                title="Aktywuj użytkownika"
                                aria-label="Aktywuj użytkownika"
                                [disabled]="
                                  isSaving() || userStatusPendingCode() === user.user_code
                                "
                                (click)="toggleUserActive(user)"
                              >
                                <span class="fa-solid fa-user-check" aria-hidden="true"></span>
                              </button>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </form>

        @if (userPendingEdit(); as editedUser) {
          <form
            class="app-panel user-admin__form"
            [formGroup]="userEditForm"
            (ngSubmit)="submitUserEdit()"
          >
            <div class="app-panel__header">
              <h3 class="app-panel__title">Edycja użytkownika</h3>
              <p class="app-panel__meta">{{ editedUser.email }}</p>
            </div>

            <div class="user-admin__grid">
              <label class="app-field">
                <span class="app-field__label">Imię</span>
                <input type="text" formControlName="first_name" autocomplete="given-name" />
              </label>

              <label class="app-field">
                <span class="app-field__label">Nazwisko</span>
                <input type="text" formControlName="last_name" autocomplete="family-name" />
              </label>
            </div>

            <div class="user-admin__grid user-admin__grid--compact">
              <label class="app-field app-field--select">
                <span class="app-field__label">Rola</span>
                <select formControlName="role">
                  <option value="BUSINESS_ADMIN">Administrator biznesowy</option>
                  <option value="MANAGER">Menedżer</option>
                  <option value="AUDITOR">Audytor</option>
                </select>
              </label>

              <label class="app-switch user-admin__switch">
                <input type="checkbox" formControlName="is_active" />
                <span class="app-switch__indicator" aria-hidden="true"></span>
                Aktywny
              </label>
            </div>

            <div class="user-admin__grid user-admin__grid--compact">
              <div class="app-field">
                <span class="app-field__label">Nowe hasło (opcjonalnie)</span>
                <div class="user-admin__password-control">
                  <input [type]="isUserPasswordVisible() ? 'text' : 'password'" formControlName="password" autocomplete="new-password" />
                  <button type="button" class="user-admin__password-toggle" [title]="isUserPasswordVisible() ? 'Ukryj hasło' : 'Pokaż hasło'" [attr.aria-label]="isUserPasswordVisible() ? 'Ukryj hasło' : 'Pokaż hasło'" [attr.aria-pressed]="isUserPasswordVisible()" (click)="toggleUserPasswordVisibility()">
                    <span [class]="isUserPasswordVisible() ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" aria-hidden="true"></span>
                  </button>
                </div>
                @if (userEditForm.controls.password.dirty && userEditForm.controls.password.hasError('strongPassword')) {
                  <span class="user-admin__field-error">
                    Hasło musi mieć co najmniej 7 znaków i zawierać małą literę, dużą literę, cyfrę oraz znak specjalny.
                  </span>
                }
              </div>
              <label class="app-switch user-admin__switch">
                <input type="checkbox" formControlName="must_change_password" />
                <span class="app-switch__indicator" aria-hidden="true"></span>
                Użytkownik musi zmienić hasło po zalogowaniu
              </label>
            </div>

            <div class="app-panel__actions">
              <button
                class="secondary-button secondary-button--compact"
                type="button"
                [disabled]="isSaving() || isLoadingUserEdit()"
                (click)="cancelUserEdit()"
              >
                Anuluj
              </button>
              <button
                class="primary-button primary-button--compact"
                type="submit"
                [disabled]="isSaving() || isLoadingUserEdit()"
              >
                <span class="fa-solid fa-floppy-disk" aria-hidden="true"></span>
                {{
                  isLoadingUserEdit()
                    ? 'Pobieranie danych...'
                    : isSaving()
                      ? 'Zapisywanie...'
                      : 'Zapisz użytkownika'
                }}
              </button>
            </div>
          </form>
        }
      }

      <div class="app-data-table-shell">
        <table class="app-data-table">
          <thead>
            <tr class="app-data-table__header-row">
              <th>Klient</th>
              <th>Schema</th>
              <th>Limit</th>
              <th>Status</th>
              <th class="user-admin__actions-header">Akcje</th>
            </tr>
          </thead>
          <tbody>
            @for (tenant of tenants(); track tenant.id) {
              <tr>
                <td>{{ tenant.name }}</td>
                <td>{{ tenant.schema }}</td>
                <td>{{ tenant.user_limit ?? 'bez limitu' }}</td>
                <td>
                  <span
                    class="app-status-chip"
                    [class.app-status-chip--active]="tenant.is_active"
                    [class.app-status-chip--archived]="!tenant.is_active"
                  >
                    {{ tenant.is_active ? 'Aktywny' : 'Nieaktywny' }}
                  </span>
                </td>
                <td class="user-admin__actions-cell">
                  <div class="app-row-actions">
                    <button
                      class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                      type="button"
                      [title]="tenant.is_active ? 'Dezaktywuj tenanta' : 'Aktywuj tenanta'"
                      [attr.aria-label]="
                        tenant.is_active ? 'Dezaktywuj tenanta' : 'Aktywuj tenanta'
                      "
                      [disabled]="isSaving()"
                      (click)="toggleTenantActive(tenant)"
                    >
                      <span
                        [class]="tenant.is_active ? 'fa-solid fa-ban' : 'fa-solid fa-circle-check'"
                        aria-hidden="true"
                      ></span>
                    </button>
                    <button
                      class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                      type="button"
                      title="Edytuj klienta"
                      aria-label="Edytuj klienta"
                      (click)="editTenant(tenant)"
                    >
                      <span class="fa-solid fa-pen-to-square" aria-hidden="true"></span>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      @if (isCreating()) {
        <form class="app-panel user-admin__form" [formGroup]="userForm" (ngSubmit)="submitUser()">
          <div class="app-panel__header">
            <h3 class="app-panel__title">Nowy użytkownik</h3>
            <p class="app-panel__meta">
              Administrator może dodać użytkownika tylko do swojego tenanta.
            </p>
          </div>

          <div class="user-admin__grid">
            <label class="app-field">
              <span class="app-field__label">Email</span>
              <input type="email" formControlName="email" autocomplete="email" />
            </label>

            <label class="app-field">
              <span class="app-field__label">Hasło startowe</span>
              <input type="password" formControlName="password" autocomplete="new-password" />
            </label>
          </div>

          <div class="user-admin__grid">
            <label class="app-field">
              <span class="app-field__label">Imię</span>
              <input type="text" formControlName="first_name" autocomplete="given-name" />
            </label>

            <label class="app-field">
              <span class="app-field__label">Nazwisko</span>
              <input type="text" formControlName="last_name" autocomplete="family-name" />
            </label>
          </div>

          <div class="user-admin__grid user-admin__grid--compact">
            <label class="app-field app-field--select">
              <span class="app-field__label">Rola</span>
              <select formControlName="role">
                <option value="AUDITOR">Audytor</option>
                <option value="MANAGER">Menedżer</option>
              </select>
            </label>

            <label class="app-switch user-admin__switch">
              <input type="checkbox" formControlName="is_active" />
              <span class="app-switch__indicator" aria-hidden="true"></span>
              Aktywny
            </label>
          </div>

          <div class="app-panel__actions">
            <button
              class="secondary-button secondary-button--compact"
              type="button"
              [disabled]="isSaving()"
              (click)="closeUserCreator()"
            >
              Anuluj
            </button>
            <button
              class="primary-button primary-button--compact"
              type="submit"
              [disabled]="isSaving()"
            >
              <span class="fa-solid fa-user-plus" aria-hidden="true"></span>
              {{ isSaving() ? 'Tworzenie...' : 'Dodaj użytkownika' }}
            </button>
          </div>
        </form>
      } @else {
        @if (userPendingEdit(); as editedUser) {
          <form
            class="app-panel user-admin__form"
            [formGroup]="userEditForm"
            (ngSubmit)="submitUserEdit()"
          >
            <div class="app-panel__header">
              <h3 class="app-panel__title">Edycja użytkownika</h3>
              <p class="app-panel__meta">{{ editedUser.email }}</p>
            </div>

            <div class="user-admin__grid">
              <label class="app-field">
                <span class="app-field__label">Imię</span>
                <input type="text" formControlName="first_name" autocomplete="given-name" />
              </label>

              <label class="app-field">
                <span class="app-field__label">Nazwisko</span>
                <input type="text" formControlName="last_name" autocomplete="family-name" />
              </label>
            </div>

            <div class="user-admin__grid user-admin__grid--compact">
              <label class="app-field app-field--select">
                <span class="app-field__label">Rola</span>
                <select formControlName="role">
                  <option value="MANAGER">Menedżer</option>
                  <option value="AUDITOR">Audytor</option>
                </select>
              </label>

              <label class="app-switch user-admin__switch">
                <input type="checkbox" formControlName="is_active" />
                <span class="app-switch__indicator" aria-hidden="true"></span>
                Aktywny
              </label>
            </div>

            <ng-container [ngTemplateOutlet]="userLocationsEditor" />

            <div class="user-admin__grid user-admin__grid--compact">
              <div class="app-field">
                <span class="app-field__label">Nowe hasło (opcjonalnie)</span>
                <div class="user-admin__password-control">
                  <input [type]="isUserPasswordVisible() ? 'text' : 'password'" formControlName="password" autocomplete="new-password" />
                  <button type="button" class="user-admin__password-toggle" [title]="isUserPasswordVisible() ? 'Ukryj hasło' : 'Pokaż hasło'" [attr.aria-label]="isUserPasswordVisible() ? 'Ukryj hasło' : 'Pokaż hasło'" [attr.aria-pressed]="isUserPasswordVisible()" (click)="toggleUserPasswordVisibility()">
                    <span [class]="isUserPasswordVisible() ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" aria-hidden="true"></span>
                  </button>
                </div>
                @if (userEditForm.controls.password.dirty && userEditForm.controls.password.hasError('strongPassword')) {
                  <span class="user-admin__field-error">
                    Hasło musi mieć co najmniej 7 znaków i zawierać małą literę, dużą literę, cyfrę oraz znak specjalny.
                  </span>
                }
              </div>
              <label class="app-switch user-admin__switch">
                <input type="checkbox" formControlName="must_change_password" />
                <span class="app-switch__indicator" aria-hidden="true"></span>
                Użytkownik musi zmienić hasło po zalogowaniu
              </label>
            </div>

            <div class="app-panel__actions">
              <button
                class="secondary-button secondary-button--compact"
                type="button"
                [disabled]="isSaving() || isLoadingUserEdit()"
                (click)="cancelUserEdit()"
              >
                Anuluj
              </button>
              <button
                class="primary-button primary-button--compact"
                type="submit"
                [disabled]="isSaving() || isLoadingUserEdit()"
              >
                <span class="fa-solid fa-floppy-disk" aria-hidden="true"></span>
                {{
                  isLoadingUserEdit()
                    ? 'Pobieranie danych...'
                    : isSaving()
                      ? 'Zapisywanie...'
                      : 'Zapisz użytkownika'
                }}
              </button>
            </div>
          </form>
        } @else {
          @if (isLoading()) {
            <div class="app-empty-state"><span class="app-message__icon app-message__icon--info fa-solid fa-circle-info" aria-hidden="true"></span> Ładowanie użytkowników...</div>
          } @else if (!users().length) {
            <div class="app-empty-state"><span class="app-message__icon app-message__icon--info fa-solid fa-circle-info" aria-hidden="true"></span> Brak użytkowników do wyświetlenia.</div>
          } @else if (!visibleUsers().length) {
            <div class="app-empty-state"><span class="app-message__icon app-message__icon--info fa-solid fa-circle-info" aria-hidden="true"></span> Brak użytkowników pasujących do wyszukiwania.</div>
          } @else if (viewMode() === 'list') {
            <div class="app-data-table-shell">
              <table class="app-data-table">
                <thead>
                  <tr class="app-data-table__header-row">
                    <th>Email (login)</th>
                    <th>Imię i nazwisko</th>
                    <th>Rola</th>
                    <th>Status</th>
                    <th class="user-admin__actions-header">Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  @for (user of visibleUsers(); track user.user_code) {
                    <tr>
                      <td>{{ user.email }}</td>
                      <td>{{ user.first_name }} {{ user.last_name }}</td>
                      <td>{{ user.role }}</td>
                      <td>
                        <span
                          class="app-status-chip"
                          [class.app-status-chip--active]="user.is_active"
                          [class.app-status-chip--archived]="!user.is_active"
                        >
                          {{ user.is_active ? 'Aktywny' : 'Nieaktywny' }}
                        </span>
                      </td>
                      <td class="user-admin__actions-cell">
                        @if (canManageUser(user)) {
                          <div class="app-row-actions">
                            <button
                              class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                              type="button"
                              title="Edytuj użytkownika"
                              aria-label="Edytuj użytkownika"
                              [disabled]="isSaving() || userStatusPendingCode() === user.user_code"
                              (click)="editUser(user)"
                            >
                              <span class="fa-solid fa-pen-to-square" aria-hidden="true"></span>
                            </button>
                            @if (user.is_active) {
                              <button
                                class="primary-button primary-button--compact app-row-action-button"
                                type="button"
                                title="Dezaktywuj użytkownika"
                                aria-label="Dezaktywuj użytkownika"
                                [disabled]="
                                  isSaving() || userStatusPendingCode() === user.user_code
                                "
                                (click)="toggleUserActive(user)"
                              >
                                <span class="fa-solid fa-user-slash" aria-hidden="true"></span>
                              </button>
                            } @else {
                              <button
                                class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                                type="button"
                                title="Aktywuj użytkownika"
                                aria-label="Aktywuj użytkownika"
                                [disabled]="
                                  isSaving() || userStatusPendingCode() === user.user_code
                                "
                                (click)="toggleUserActive(user)"
                              >
                                <span class="fa-solid fa-user-check" aria-hidden="true"></span>
                              </button>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="app-card-grid">
              @for (user of visibleUsers(); track user.user_code) {
                <article class="app-data-card user-admin__card">
                  <div class="app-data-card__header user-admin__card-header">
                    <h3 class="user-admin__card-title">
                      {{ user.first_name }} {{ user.last_name }}
                    </h3>
                    <span
                      class="app-status-chip"
                      [class.app-status-chip--active]="user.is_active"
                      [class.app-status-chip--archived]="!user.is_active"
                    >
                      {{ user.is_active ? 'Aktywny' : 'Nieaktywny' }}
                    </span>
                  </div>

                  <dl class="user-admin__card-details">
                    <div>
                      <dt>Email (login)</dt>
                      <dd>{{ user.email }}</dd>
                    </div>
                    <div>
                      <dt>Rola</dt>
                      <dd>{{ user.role }}</dd>
                    </div>
                  </dl>

                  <footer
                    class="app-data-card__footer user-admin__card-footer"
                    [class.app-data-card__footer--empty]="!canManageUser(user)"
                    [attr.aria-hidden]="canManageUser(user) ? null : 'true'"
                  >
                    @if (canManageUser(user)) {
                      <div class="app-row-actions">
                        <button
                          class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                          type="button"
                          title="Edytuj użytkownika"
                          aria-label="Edytuj użytkownika"
                          [disabled]="isSaving() || userStatusPendingCode() === user.user_code"
                          (click)="editUser(user)"
                        >
                          <span class="fa-solid fa-pen-to-square" aria-hidden="true"></span>
                        </button>
                        @if (user.is_active) {
                          <button
                            class="primary-button primary-button--compact app-row-action-button"
                            type="button"
                            title="Dezaktywuj użytkownika"
                            aria-label="Dezaktywuj użytkownika"
                            [disabled]="isSaving() || userStatusPendingCode() === user.user_code"
                            (click)="toggleUserActive(user)"
                          >
                            <span class="fa-solid fa-user-slash" aria-hidden="true"></span>
                          </button>
                        } @else {
                          <button
                            class="secondary-button secondary-button--compact secondary-button--indigo app-row-action-button"
                            type="button"
                            title="Aktywuj użytkownika"
                            aria-label="Aktywuj użytkownika"
                            [disabled]="isSaving() || userStatusPendingCode() === user.user_code"
                            (click)="toggleUserActive(user)"
                          >
                            <span class="fa-solid fa-user-check" aria-hidden="true"></span>
                          </button>
                        }
                      </div>
                    } @else {
                      <span class="app-action-placeholder" aria-hidden="true"></span>
                      <span class="app-action-placeholder" aria-hidden="true"></span>
                    }
                  </footer>
                </article>
              }
            </div>
          }
        }
      }
    }
  </section>

  <ng-template #userLocationsEditor>
    <section class="user-admin__locations" aria-label="Przypisane lokalizacje">
      <div class="user-admin__locations-header">
        <div>
          <h4>Przypisane lokalizacje</h4>
          <p>Użytkownik może mieć dostęp do wielu lokalizacji.</p>
        </div>
        <button class="secondary-button secondary-button--compact" type="button" (click)="openLocationDialog()">
          <span class="fa-solid fa-plus" aria-hidden="true"></span>
          Nowa lokalizacja
        </button>
      </div>
      @if (locations().length) {
        <div class="user-admin__location-options">
          @for (location of locations(); track location.id) {
            <label class="user-admin__location-option" [class.user-admin__location-option--inactive]="location.status !== 'active'">
              <input type="checkbox" [checked]="isLocationSelected(location.id)" (change)="toggleLocation(location.id, $any($event.target).checked)" />
              <span>{{ location.name }}</span>
              @if (location.status !== 'active') { <small>Nieaktywna</small> }
            </label>
          }
        </div>
      } @else {
        <p class="user-admin__locations-empty">Brak lokalizacji. Utwórz pierwszą lokalizację.</p>
      }
    </section>
  </ng-template>

  @if (isLocationDialogOpen()) {
    <div class="user-admin__modal" role="presentation" (click)="closeLocationDialog()">
      <section class="user-admin__modal-panel" role="dialog" aria-modal="true" aria-labelledby="new-location-title" (click)="$event.stopPropagation()">
        <div class="app-panel__header">
          <h3 class="app-panel__title" id="new-location-title">Nowa lokalizacja</h3>
          <p class="app-panel__meta">Po utworzeniu zostanie od razu przypisana do edytowanego użytkownika.</p>
        </div>
        <form class="app-form" [formGroup]="locationForm" (ngSubmit)="submitLocation()">
          <label class="app-field">
            <span class="app-field__label">Nazwa lokalizacji</span>
            <input type="text" formControlName="name" maxlength="255" autocomplete="off" />
            @if (locationForm.controls.name.touched && locationForm.controls.name.invalid) {
              <span class="user-admin__field-error">Podaj nazwę lokalizacji.</span>
            }
          </label>
          <div class="app-panel__actions">
            <button class="secondary-button secondary-button--compact" type="button" [disabled]="isCreatingLocation()" (click)="closeLocationDialog()">Anuluj</button>
            <button class="primary-button primary-button--compact" type="submit" [disabled]="isCreatingLocation()">
              {{ isCreatingLocation() ? 'Tworzenie...' : 'Utwórz lokalizację' }}
            </button>
          </div>
        </form>
      </section>
    </div>
  }
}
